"use client";

import { DashboardShell } from "@/components/dashboard/dashboard-shell";
import { MyListingsView } from "@/components/marketplace/my-listings-view";

export function ListingsPage() {
  return (
    <DashboardShell title="My Marketplace Listings">
      <MyListingsView />
    </DashboardShell>
  );
}

export default ListingsPage;
